// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608112048/js/" + chunkId + "." + {"44":"ee1d3529","225":"8a9c3bb7","481":"9eab0709","486":"63633a40","770":"c9db5d04"}[chunkId] + ".0.8822908556345879.chunk.js";
};